import React from "react";
import { Link } from "react-router-dom";

const MobileDevelopment = () => {
  return (
    <>
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('img/erp.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-5 ">MOBILE APP DEVELOPMENT</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  MOBILE APP DEVELOPMENT
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
            <img
              src="/img/Mobile-App-Development.jpg"
              width="100%"
              height="50%"
              alt="ERP Implementation Services"
              className="img-fluid rounded-3"
            />
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <h2 className="fw-bold mb-1">ANDROID APP DEVELOPMENT</h2>
            <p className="fs-5">
              At DigiOpen Services, we help businesses harness the power of
              mobile technology through innovative, high-performance Android
              application development services. Acting as a trusted extension of
              our clients' teams, we design and develop mobile applications that
              drive business growth, enhance customer engagement, and strengthen
              brand presence in an increasingly mobile-first world.
              <p className="fs-5 pt-2 ">
                With a proven track record of delivering over 20 successful
                mobile applications, we have the expertise and experience to
                transform your ideas into scalable, user-friendly Android
                solutions tailored to your business objectives.
              </p>
            </p>
            <strong>Our Android Development Expertise</strong>
            <ul className="list-style-one d-flex flex-wrap">
              <li className="col-12 mb-2">
                Custom Android Application Development
              </li>
              <li className="col-12 mb-2">Enterprise Mobility Solutions </li>
              <li className="col-12 mb-2">
                Business and Customer Engagement Apps{" "}
              </li>
              <li className="col-12 mb-2">
                UI/UX Design Based on Material Design Principles{" "}
              </li>
              <li className="col-12 mb-2">
                API Integration and Backend Connectivity{" "}
              </li>
              <li className="col-12 mb-2">
                Application Testing, Deployment, and Maintenance{" "}
              </li>
              <li className="col-12 mb-2">
                Performance Optimization and Scalability Enhancements{" "}
              </li>
            </ul>

          </div>
        </div>
      </div>

      
    </>
  );
};

export default MobileDevelopment;